import { Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { FormStatusAdminEnum } from "../../_common/enum/forms/formStatusAdmin.enum";
import { getEnumDropdown } from "../../_helpers/form.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { PrimaryButton } from "../button/primary.button";
import { TextValidatorHcs } from "../textValidator/textValidatorHcs";
import { toastr } from "../toastr/toastr";


export function EmailLogComment() {

    const [isLoading, setLoading] = useState(false);
    const { formId } = useParams<{ formId: string }>();
    const _formId = Number(formId);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState({
        id: _formId,
        comment: "",
        formStatusAdminId: ""
    });

    function submit() {
        setIsSaving(true);

        return formService
            .updateComment(data)
            .then(
                (json) => {
                    toastr.success("success");
                    // navigate("/Forms");
                }
            )
            .finally(() => {
                setIsSaving(false);
            });
    }

    useEffect(() => {
        if (formId != null)
            fetchData();
    }, [formId]);

    function fetchData() {

        return formService.getComment(_formId)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        console.log(event.target);
        setData((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (

        <Paper>
            <ValidatorForm onSubmit={submit} noValidate>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {getEnumDropdown("Form Admin Status", "formStatusAdminId", FormStatusAdminEnum, data?.formStatusAdminId, handleChange, false, "outlined")}
                    </Grid>

                    <Grid item xs={12}>

                        <TextValidatorHcs
                            label={"Comment"}
                            value={data?.comment}
                            name={"comment"}
                            fullWidth
                            multiline
                            type={"text"}
                            rows={12}
                            variant={"outlined"}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <PrimaryButton disabled={!data?.comment && !data?.formStatusAdminId} icon={"save"} isLoading={isLoading} isSaving={isSaving} variant="primary" type="submit">Update</PrimaryButton>
            </ValidatorForm>
        </Paper>


    );

}
